export default __webpack_public_path__ + "static/media/undraw_profile_3.0c5231bd.svg";